import { render, staticRenderFns } from "./Gly.vue?vue&type=template&id=1428d306&scoped=true&"
import script from "./Gly.vue?vue&type=script&lang=js&"
export * from "./Gly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1428d306",
  null
  
)

export default component.exports